import heroField from "../assets/img/hero-field.png";
import { HeadlineRoll, LetterLine } from "./HeadlineRoll";

const SPARKS = [
  { x: 8, y: 18, s: 7, d: 0.2, dur: 2.6, tone: "gold" },
  { x: 16, y: 42, s: 5, d: 1.1, dur: 3.4, tone: "cream" },
  { x: 23, y: 12, s: 4, d: 0.7, dur: 2.2, tone: "gold" },
  { x: 31, y: 58, s: 6, d: 1.8, dur: 3.1, tone: "coral" },
  { x: 38, y: 22, s: 5, d: 0.4, dur: 2.8, tone: "gold" },
  { x: 47, y: 8, s: 8, d: 1.4, dur: 3.6, tone: "cream" },
  { x: 54, y: 36, s: 4, d: 0.9, dur: 2.4, tone: "gold" },
  { x: 62, y: 14, s: 6, d: 2.1, dur: 2.9, tone: "gold" },
  { x: 69, y: 48, s: 5, d: 0.3, dur: 3.3, tone: "coral" },
  { x: 74, y: 26, s: 9, d: 1.6, dur: 2.7, tone: "gold" },
  { x: 81, y: 11, s: 4, d: 0.6, dur: 2.5, tone: "cream" },
  { x: 86, y: 39, s: 7, d: 2.4, dur: 3.2, tone: "gold" },
  { x: 91, y: 19, s: 5, d: 1.2, dur: 2.8, tone: "gold" },
  { x: 12, y: 72, s: 4, d: 1.9, dur: 3.5, tone: "cream" },
  { x: 28, y: 78, s: 6, d: 0.8, dur: 2.6, tone: "gold" },
  { x: 44, y: 68, s: 5, d: 2.2, dur: 3.0, tone: "coral" },
  { x: 58, y: 74, s: 4, d: 0.5, dur: 2.3, tone: "gold" },
  { x: 77, y: 64, s: 8, d: 1.5, dur: 3.4, tone: "cream" },
  { x: 93, y: 56, s: 5, d: 2.0, dur: 2.7, tone: "gold" },
  { x: 4, y: 51, s: 3, d: 1.3, dur: 2.1, tone: "gold" },
  { x: 66, y: 82, s: 4, d: 0.1, dur: 2.9, tone: "cream" },
  { x: 19, y: 31, s: 6, d: 2.6, dur: 3.7, tone: "gold" },
];

const Disk = ({ spinning }) => (
  <div className={`disk ${spinning ? "spinning" : ""}`} aria-hidden="true">
    <div className="disk-face" />
    <span className="disk-cap c1" />
    <span className="disk-cap c2" />
    <span className="disk-cap c3" />
  </div>
);

export const Banner = ({ musicOn, onToggleMusic, musicClock }) => {
  const total = Math.max(1, Math.round(musicClock?.d || 174));
  const elapsed = Math.max(0, Math.min(total, musicClock?.t || 0));
  const progress = (elapsed / total) * 100;
  const fmt = (n) => `${Math.floor(n / 60)}:${String(Math.floor(n) % 60).padStart(2, "0")}`;

  return (
    <section className="hero" id="home">
      <div
        className="hero-field"
        style={{ backgroundImage: `url(${heroField})` }}
        aria-hidden="true"
      />
      <div className="hero-shader" aria-hidden="true" />
      <div className="hero-constellation" aria-hidden="true" />
      <div className="hero-stars" aria-hidden="true" />
      <div className="hero-noise" aria-hidden="true" />
      <div className="hero-sparkles" aria-hidden="true">
        {SPARKS.map((spark, index) => (
          <span
            className={`spark spark-${spark.tone}`}
            key={`${spark.x}-${spark.y}`}
            style={{
              left: `${spark.x}%`,
              top: `${spark.y}%`,
              width: spark.s,
              height: spark.s,
              animationDelay: `${spark.d}s`,
              animationDuration: `${spark.dur}s`,
            }}
          />
        ))}
        <span className="shooting-star ss-a" />
        <span className="shooting-star ss-b" />
        <span className="shooting-star ss-c" />
        <span className="shooting-star ss-d" />
        <span className="shooting-star ss-e" />
      </div>

      <div className="hero-content" id="hero-content">
        <p className="hero-eyebrow">
          <span className="kicker-dot" />
          <span className="hero-hello">
            <span className="hero-name">Sukrit Phaopanich</span>
            <span className="hero-role"> · Full-stack PM</span>
          </span>
        </p>

        <h1>
          <span className="sr-only">
            Sukrit Phaopanich, a full-stack product manager who takes a product from the bet to something people can measure
          </span>
          <span className="hero-vertical" aria-hidden="true">
            PRODUCT / INSIGHTS / AI
          </span>
          <LetterLine className="h-line multidisciplinary" text="AI PM who" />
          <HeadlineRoll />
        </h1>

        <p className="hero-claim">
          From the bet to a product people can <em>measure</em>.
        </p>

        <div className="recorder" role="region" aria-label="Career snapshot player">
          <Disk spinning={musicOn} />
          <div className="rec-center">
            <p className="rec-title">My product journey</p>
            <p className="rec-credit">Kevin MacLeod · Night on the Docks</p>
            <div className="play-slider">
              <div className="slider-track">
                <div className="slider-fill" style={{ width: `${progress}%` }} />
              </div>
              <div className="slider-knob" style={{ left: `calc(${progress}% - 12px)` }} />
            </div>
            <div className="timestamps">
              <span>{fmt(elapsed)}</span>
              <span>{fmt(total)}</span>
            </div>
            <button
              className="play-circle"
              type="button"
              onClick={onToggleMusic}
              aria-label={musicOn ? "Pause" : "Play"}
            >
              {musicOn ? (
                <span className="pause-bars" aria-hidden="true">
                  <span />
                  <span />
                </span>
              ) : (
                <span className="tri" aria-hidden="true" />
              )}
            </button>
          </div>
          <Disk spinning={musicOn} />
        </div>
      </div>
    </section>
  );
};
